export default __webpack_public_path__ + "static/media/Aa.0b040751.wav";